import api from '../index.js'

export default {
  getCustomerDeviceLogs(customer_id, params) {
    return api.get(`/v2/owners/customers/${customer_id}/device_logs`, params)
  }
}
